<!-- Initial template -->
<mat-dialog-content>
  <form [formGroup]="carparkFormGrp" #formRef="ngForm">
    <div
      class="dialog"
      *ngFor="let obj of unitList; let i = index"
      fxLayout="row"
      fxLayoutAlign="space-around center"
    >
      <div fxFlex="30">
        <mat-label>Unit</mat-label>
        <div>{{ obj.title }}</div>
      </div>

      <div class="right">
        <mat-form-field>
          <mat-chip-list #chipList aria-label="Car Park selection">
            <mat-chip
              multiple
              *ngFor="let cp of obj.carPark"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeCarPark(cp)"
            >
              {{cp.name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input
              placeholder="Select Car Park.."
              #carParkInput
              [formControl]="carParkCtrl"
              [matAutocomplete]="carpark"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addCarPark($event)"
              required
            />
          </mat-chip-list>
          <mat-autocomplete
            #carpark="matAutocomplete"
            (optionSelected)="selectedCarPark($event,i)"
          >
            <mat-option
              *ngFor="let carpark of filteredCarPark;"
              [value]="carpark"
            >
              {{carpark.unitNo}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<div class="dialog-buttons">
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="false"
    (click)="cancel()"
  >
    Cancel
  </button>
  <button (click)="save()" mat-button color="primary">Save</button>
</div>

<!-- <div class="dialog-title">Car Park Assignment</div> -->
<!-- FormGroup, FormControl, ngModel -->
<!-- <mat-dialog-content>
  <form [formGroup]="bookingFormGrp">
    <div
      class="dialog"
      *ngFor="let obj of unitList;"
      fxLayout="row"
      fxLayoutAlign="space-around center"
    >
      <div fxFlex="30">
        <mat-label>Unit</mat-label>
        <div>{{ obj.title }}</div>
      </div>

      <div class="right">
        <mat-form-field>
          <mat-chip-grid #chipList aria-label="Car Park Selection">
            <mat-chip
              *ngFor="let carpark of choosenCarpark"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeCarPark(carpark)"
            >
              {{ carpark.unitNo}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input
              placeholder="Select A Car Park Unit"
              #carParkInput
              [(ngModel)]="carpark"
              [ngModelOptions]="{ standalone: true}"
              formControl="bookingFormGrp.controls['carpark']"
              [matAutocomplete]="carpark"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addCarPark($event)"
              required
            />
          </mat-chip-grid>
          <mat-autocomplete
            #carpark="matAutocomplete"
            (optionSelected)="selectedCarPark($event)"
          >
            <mat-option
              *ngFor="let carpark of filteredCarPark;"
              [value]="carpark"
            >
              {{carpark.unitNo}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content> -->

<!-- FormGroup, FormArrayName, FormControlArray -->
<!-- <mat-dialog-content>
  <form [formGroup]="bookingFormGrp">
    <div formArrayName="unitList">
      <div
        *ngFor="let obj of unitList"
        class="dialog"
        fxLayout="row"
        fxLayoutAlign="space-around center"
      >
        <div fxFlex="30">
          <mat-label>Unit</mat-label>
          <div>{{ obj.title }}</div>
        </div>

        <div class="right">
          <mat-form-field>
            <mat-chip-list #chipList aria-label="Car Park Selection">
              <mat-chip-grid>
                <mat-chip-row
                  *ngFor="let carpark of choosenCarpar"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeCarPark(carpark)"
                >
                  <input
                    placeholder="Select A Car Park Unit"
                    #carParkInput
                    [matAutocomplete]="carpark"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addCarPark($event)"
                    required
                  />
                </mat-chip-row>
              </mat-chip-grid>
            </mat-chip-list>
            <mat-autocomplete
              #carpark="matAutocomplete"
              (optionSelected)="selectedCarPark($event)"
            >
              <mat-option
                *ngFor="let carpark of filteredCarPark;"
                [value]="carpark"
              >
                {{carpark.unitNo}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content> -->

<!-- Form Control Array -->
<!-- <div formArrayName="unitList">
  <div>
    <div [formGroup]="obj">
      <form #formRef="ngForm">
        <div
          *ngFor="let obj of unitList.controls; let i = index"
          class-="dialog"
          fxLayout="row"
          fxLayoutAlign="space-around center"
        >
          <div fxFlex="30">
            <mat-label formControlName="unit">Unit</mat-label>
            <div>{{ obj.title }}</div>
          </div>

          <div class="right">
            <mat-form-field>
              <mat-chip-list #chipList aria-label="Car Park Selection">
                <mat-chip
                  *ngFor="let carpark of choosenCarpark"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeCarPark(carpark)"
                >
                  {{carpark.unitNo}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input
                  placeholder="Select A Car Park Unit"
                  #carParkInput
                  [matAutocomplete]="carpark"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addCarPark($event)"
                  required
                />
              </mat-chip-list>
              <mat-autocomplete
                #carpark="matAutocomplete"
                (optionSelected)="selectedCarPark($event)"
              >
                <mat-option
                  *ngFor="let carpark of filteredCarPark;"
                  [value]="carpark"
                  >
                  {{carpark.unitNo}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>
</div> -->
